/**
 * @generated SignedSource<<9687bf93bf6d509efe80f01593416357>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleHeadlineHeaderFeaturesArticle$data = {
  readonly headline: string | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly " $fragmentType": "articleHeadlineHeaderFeaturesArticle";
};
export type articleHeadlineHeaderFeaturesArticle$key = {
  readonly " $data"?: articleHeadlineHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleHeadlineHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "articleHeadlineHeaderFeaturesArticle"
};

(node as any).hash = "05e310aed0511fda7065c02684a89f80";

export default node;
